/* STANHOPE GATEWAY — terminal sequence, pill navigation, CRT transition */
(function () {
  "use strict";

  var QUOTE =
    "This is your last chance. After this, there is no turning back.\n\n" +
    "You take the blue pill—the story ends, you wake up in your bed and believe whatever you want to believe.\n\n" +
    "You take the red pill—you stay in Wonderland, and I show you how deep the rabbit hole goes.";

  var reduced = false;
  try { reduced = matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}

  var screen  = document.getElementById("sgScreen");
  var inner   = document.getElementById("sgScreenInner");
  var textEl  = document.getElementById("sgText");
  var beam    = document.getElementById("sgBeam");
  var skipEl  = document.getElementById("sgSkip");
  var pills   = document.getElementById("sgPills");
  var led     = document.getElementById("sgLed");
  var fade    = document.getElementById("sgFade");
  var fxBtn   = document.getElementById("sgEffects");
  if (!screen || !textEl) return;

  /* ---- plain-effects mode (persisted) ---- */
  var PLAIN_KEY = "stanhope_crt_plain";
  function setPlain(on) {
    document.body.classList.toggle("sg-plain", on);
    if (fxBtn) fxBtn.textContent = on ? "EFFECTS: PLAIN" : "EFFECTS: CRT";
    try { localStorage.setItem(PLAIN_KEY, on ? "1" : "0"); } catch (e) {}
  }
  var plainSaved = false;
  try { plainSaved = localStorage.getItem(PLAIN_KEY) === "1"; } catch (e) {}
  setPlain(plainSaved);
  if (fxBtn) fxBtn.addEventListener("click", function () {
    setPlain(!document.body.classList.contains("sg-plain"));
  });

  /* ---- analog noise texture (generated, tiny) ---- */
  try {
    var nc = document.createElement("canvas"); nc.width = nc.height = 96;
    var nx = nc.getContext("2d"), img = nx.createImageData(96, 96);
    for (var i = 0; i < img.data.length; i += 4) {
      var v = 110 + Math.random() * 145 | 0;
      img.data[i] = img.data[i + 1] = img.data[i + 2] = v; img.data[i + 3] = 255;
    }
    nx.putImageData(img, 0, 0);
    var noiseURL = "url(" + nc.toDataURL() + ")";
    document.querySelectorAll(".sg-fx.noise,.sg-pill .grain").forEach(function (el) {
      el.style.backgroundImage = noiseURL;
    });
  } catch (e) {}

  /* ---- typing engine ---- */
  var idx = 0, done = false, timer = null, cursor = null, armed = false;
  var ARM_AT = Math.floor(QUOTE.length * 0.55);

  function makeCursor() {
    cursor = document.createElement("span");
    cursor.className = "sg-cursor blink";
    cursor.setAttribute("aria-hidden", "true");
    return cursor;
  }
  function render() {
    textEl.textContent = QUOTE.slice(0, idx);
    textEl.appendChild(cursor || makeCursor());
  }
  function delayFor(ch, next) {
    var d = 25 + Math.random() * 20;
    if (ch === "," || ch === ";") d += 150;
    if (ch === "." || ch === "—") d += 240;
    if (ch === "\n" && next === "\n") d += 620;   /* paragraph break */
    return d;
  }
  function arm() {
    if (armed) return; armed = true;
    pills.classList.add("armed");
    pills.querySelectorAll(".sg-choice").forEach(function (a) {
      a.removeAttribute("aria-disabled"); a.removeAttribute("tabindex");
    });
    prefetchTargets();
  }
  function finish() {
    if (done) return; done = true;
    idx = QUOTE.length; render(); arm();
    if (skipEl) skipEl.classList.remove("show");
    var live = document.getElementById("sgLive");
    if (live) live.textContent = "Terminal message complete. Choose the red pill for the Store or the blue pill for the Sandbox.";
  }
  function step() {
    if (done) return;
    if (idx >= QUOTE.length) { finish(); return; }
    idx++; render();
    if (idx >= ARM_AT) arm();
    timer = setTimeout(step, delayFor(QUOTE[idx - 1] || "", QUOTE[idx] || ""));
  }
  function skip(ev) {
    if (done) return;
    if (ev && ev.type === "keydown" && (ev.metaKey || ev.ctrlKey || ev.altKey)) return;
    clearTimeout(timer); finish();
  }
  addEventListener("keydown", skip);
  screen.addEventListener("pointerdown", skip);

  /* ---- warm-up sequence ---- */
  function warmup() {
    if (reduced || document.body.classList.contains("sg-plain")) {
      screen.classList.add("on"); textEl.style.opacity = "1";
      if (led) led.classList.add("on");
      finish(); return;
    }
    if (led) setTimeout(function(){ led.classList.add("on"); }, 300);
    /* 1: beam appears */
    setTimeout(function () {
      beam.style.transition = "transform .5s cubic-bezier(.2,.8,.3,1), opacity .2s";
      beam.style.opacity = "1";
      beam.style.transform = "translateY(-50%) scaleX(1)";
    }, 420);
    /* 2: bloom opens, phosphor stabilizes */
    setTimeout(function () {
      beam.style.transition = "opacity .55s, filter .55s";
      beam.style.opacity = "0"; beam.style.filter = "blur(8px)";
      screen.classList.add("on");
      textEl.style.opacity = "1";
      render(); /* cursor blinks alone first */
    }, 1150);
    /* 3: typing begins */
    setTimeout(step, 1900);
    /* skip hint */
    setTimeout(function () { if (!done && skipEl) skipEl.classList.add("show"); }, 2600);
  }
  render();
  warmup();

  /* ---- prefetch destinations ---- */
  var prefetched = {};
  function prefetch(href) {
    if (!href || prefetched[href]) return; prefetched[href] = 1;
    var l = document.createElement("link");
    l.rel = "prefetch"; l.href = href; l.as = "document";
    document.head.appendChild(l);
  }
  function prefetchTargets() {
    pills.querySelectorAll(".sg-choice").forEach(function (a) { prefetch(a.getAttribute("href")); });
  }
  pills.addEventListener("pointerenter", function (ev) {
    var a = ev.target.closest ? ev.target.closest(".sg-choice") : null;
    if (a) prefetch(a.getAttribute("href"));
  }, true);

  /* ---- CRT power-down transition ---- */
  var leaving = false;
  pills.addEventListener("click", function (ev) {
    var a = ev.target.closest ? ev.target.closest(".sg-choice") : null;
    if (!a || a.getAttribute("aria-disabled") === "true") return;
    ev.preventDefault();
    if (leaving) return; leaving = true;
    var href = a.getAttribute("href");
    if (reduced || document.body.classList.contains("sg-plain")) {
      fade.classList.add("on");
      setTimeout(function () { location.href = href; }, 160);
      return;
    }
    /* pill press acknowledgement, then collapse */
    setTimeout(function () {
      document.getElementById("sgMonitor").classList.add("sg-collapse");
      if (led) led.classList.remove("on");
      setTimeout(function () { fade.classList.add("on"); }, 620);
      setTimeout(function () { location.href = href; }, 800);
    }, 90);
  });

  /* keyboard activation already works: choices are <a>; Enter triggers click */

  /* restore state if user navigates back (bfcache) */
  addEventListener("pageshow", function (ev) {
    if (ev.persisted) {
      leaving = false;
      fade.classList.remove("on");
      var m = document.getElementById("sgMonitor");
      if (m) m.classList.remove("sg-collapse");
      if (led) led.classList.add("on");
    }
  });
})();
